<template>
	<div>
		<Loader :show="loading" type="inline" />
		<Loader :show="saving" />

		<FormulateForm v-if="!loading" v-model="form" ref="form" @submit="save">
			<FormulateInput
				label="Nombre del lugar"
				name="aaaaa"
				validation-name="Nombre del lugar"
				validation="required"
			/>

			<div class="row row-xs mb-4">
				<div class="col-6">
					<FormulateInput
						label="Departamento"
						name="bbbbb"
						type="selectSearch"
						:options="regions"
						validation-name="Departamento"
						validation="required"
						@selected="onRegionSelected"
						optionValue="id"
						optionText="name"
					/>
				</div>
				<div class="col-6">
					<FormulateInput
						label="Ciudad"
						name="ccccc"
						type="selectSearch"
						:options="localitiesFiltered"
						validation-name="Ciudad"
						validation="required"
						optionValue="id"
						optionText="name"
					/>
				</div>
			</div>

			<FormulateInput
				label="Dirección"
				name="ddddd"
				type="text"
				validation-name="Dirección"
				validation="required"
			/>

			<FormulateInput
				type="latlng"
				label="Ubicación"
				name="latlng"
				validation-name="Ubicación"
				validation="required"
			/>

			<FormulateInput name="saveOnLocations" type="checkbox" label="Guardar en mis ubicaciones" />

			<hr />

			<div class="d-flex justify-content-between mt-4">
				<div class="btn btn-light" @click="$emit('close')">
					Cancelar
				</div>
				<div class="btn btn-primary disabled" v-if="saving">Guardando <span class="loader" /></div>
				<button type="submit" class="btn btn-primary" v-if="!saving">
					Continuar
				</button>
			</div>
		</FormulateForm>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "LocationForm",
	props: {
		location: {
			type: Object,
			required: false
		}
	},

	data() {
		return {
			loading: true,
			saving: false,
			title: "Crear ubicación",
			action: "create",
			form: {
				id: null,
				aaaaa: null,
				bbbbb: null,
				ccccc: null,
				ddddd: null,
				latlng: null
			},
			locations: [],
			regions: []
		}
	},

	computed: {
		localitiesFiltered() {
			const regionSelected = this.form.bbbbb ? this.regions.find((region) => region.id == this.form.bbbbb) : null
			return regionSelected ? regionSelected.localities : []
		}
	},

	async beforeMount() {
		this.loading = true
		await this.fetchData()
		if (this.location) {
			this.action = "update"
			this.form = {
				id: this.location.id,
				aaaaa: this.location.name,
				bbbbb: this.location.locality.region.id,
				ccccc: this.location.locality.id,
				ddddd: this.location.address,
				latlng: this.location.latlng
			}
		}
		this.loading = false
	},

	methods: {
		onLocationSelected(location) {
			if (location && location.id) {
				this.form = {
					id: location.id,
					aaaaa: location.name,
					bbbbb: location.locality.region.id,
					ccccc: location.locality.id,
					ddddd: location.address,
					latlng: location.latlng
				}
			}
		},

		// selecciono un departamento, filtro las ciudades
		onRegionSelected() {
			this.form.ccccc = null
		},

		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					name: this.form.aaaaa,
					locality: this.form.ccccc,
					address: this.form.ddddd,
					latlng: this.form.latlng ? { lat: this.form.latlng.lat, lng: this.form.latlng.lng } : null
				}

				if (this.action == "create") await this.create(data)
				if (this.action == "update") await this.update(data)

				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: EventLocationInput!) {
							eventLocationCreate(data: $data) {
								id
								name
								address
								locality {
									id
									name
									region {
										id
										name
									}
								}
							}
						}
					`,
					variables: {
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Ubicación creada correctamente")
					this.$emit("updated", data.eventLocationCreate)
					return data.eventLocationCreate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		async update(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: EventLocationInput!) {
							eventLocationUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.form.id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Ubicación editada correctamente")
					this.$emit("updated", data.eventLocationUpdate)
					return data.eventLocationUpdate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query {
							regions {
								id
								name
								localities {
									id
									name
								}
							}
						}
					`,
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.regions = data.regions
					return data.regions
				})
		}
	}
}
</script>

<style scoped lang="scss"></style>
